var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 18,
    viewBox: "0 0 100 18",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#444",
    d: "M89 4h3.012l4.793 6.342V4H100v12h-2.828l-4.977-6.583V16H89V4M50 4h5.655c1.845 0 3.09.48 3.894 1.304.7.685 1.06 1.61 1.06 2.792v.035c0 1.853-.958 3.051-2.461 3.684L61 16h-3.825l-2.409-3.634h-1.452V16H50V4zm5.5 5.76c1.145 0 1.777-.548 1.777-1.422v-.036c0-.959-.682-1.422-1.794-1.422h-2.17v2.88h2.188zM33 4h5.653c1.845 0 3.092.48 3.895 1.304.7.685 1.059 1.61 1.059 2.792v.035c0 1.853-.956 3.051-2.46 3.684L44 16h-3.827l-2.408-3.634h-1.451V16H33V4zm5.5 5.76c1.145 0 1.777-.548 1.777-1.422v-.036c0-.959-.684-1.422-1.794-1.422h-2.17v2.88H38.5z"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#444"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.056 4.184h9.635v2.971h-6.35v1.91h5.75v2.753h-5.75v1.998h6.436v2.973h-9.721V4.184M3.593 7.246H0v-3.06h10.508v3.06H6.914v9.543h-3.32V7.246"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#E29000",
    d: "M74 4h4.15L83 16h-4.496L74 4"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#C01B09",
    d: "M66 16h4.63L77 0h-4.22L66 16"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.af580515c2b3efbdd5931154c1f55126.svg";
export { ForwardRef as ReactComponent };